"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brouillonsDevisColumns = void 0;
const globals_1 = require("./globals");
const lists_1 = require("./lists");
exports.brouillonsDevisColumns = [
    {
        id: "unid", header: (0, globals_1._)("Id"), width: 80,
        css: { "text-align": "right" }, sort: "int", hidden: true
    },
    {
        id: "idTypeDocument", header: (0, globals_1._)("Type"), width: "90", editor: "select",
        options: lists_1.typeDocumentList, sort: "text"
    }, {
        id: "dateDocument", header: (0, globals_1._)("Date"), width: "120",
        sort: "raw", format: webix.i18n.dateFormatStr
    },
    {
        id: "adresseNom", header: (0, globals_1._)("Nom client"), width: "300",
        sort: "text",
        footer: { text: "Totaux" }
    },
    {
        id: "totalHT", header: (0, globals_1._)("Total HT"), width: "130",
        sort: "int",
        format: function (value) {
            return webix.i18n.numberFormat(value);
        },
        css: { "text-align": "right" },
        footer: { content: "summColumn", css: { "text-align": "right" } }
    }, {
        id: "totalTTC", header: (0, globals_1._)("Total TTC"), width: "130",
        sort: "int",
        format: function (value) {
            return webix.i18n.numberFormat(value);
        },
        css: { "text-align": "right" },
        footer: { content: "summColumn", css: { "text-align": "right" } }
    }
];
